import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import { selectHasPermission } from "../store/slices/authSlice";
import SubSessionTypeList from "../pages/SubSessionType/SubSessionTypeList";
import {
    fetchSubSessionMasters,
    deleteSubSessionMaster,
} from "../store/slices/subSessionSlice";

const SubSessionTypes = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const canManageSubSessionTypes = useSelector((state) =>
        selectHasPermission(state, "sub-session-types-manage")
    );
    const canCreateSubSessionTypes = useSelector((state) =>
        selectHasPermission(state, "sub-session-types-create")
    );
    const canEditSubSessionTypes = useSelector((state) =>
        selectHasPermission(state, "sub-session-types-edit")
    );
    const canDeleteSubSessionTypes = useSelector((state) =>
        selectHasPermission(state, "sub-session-types-delete")
    );

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        dispatch(fetchSubSessionMasters()).finally(() => setIsLoading(false));
    }, [dispatch]);

    const handleAddSubSessionType = () => navigate("/sub-session-types/add");
    const handleEditSubSessionType = (id) => navigate(`/sub-session-types/edit/${id}`);
    const handleDeleteSubSessionType = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this sub session type?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteSubSessionMaster(id)).unwrap();
                Swal.fire("Deleted!", "Sub Session Type has been deleted.", "success");
            } catch (err) {
                Swal.fire("Error!", err.message || "Failed to delete sub session type.", "error");
            }
        }
    };

    if (!canManageSubSessionTypes) {
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage sub session types." }}
                replace
            />
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <SubSessionTypeList
                                onEditSubSessionType={canEditSubSessionTypes ? handleEditSubSessionType : null}
                                onDeleteSubSessionType={canDeleteSubSessionTypes ? handleDeleteSubSessionType : null}
                                onAddSubSessionType={canCreateSubSessionTypes ? handleAddSubSessionType : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SubSessionTypes;
